import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { loginSuccess, setGuestMode } from '../../slices/authSlice';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';

const Login = () => {
  
  // username 대신 nickname을 사용합니다.
  const [nickname, setNickname] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    if (e) e.preventDefault();
    try {
      // 서버의 새로운 로직에 맞춰 nickname과 password 전송
      const res = await axios.post('/api/auth/login', { nickname, password });
    
      // 서버가 준 res.data (안에는 token과 user가 들어있음)를 그대로 보냅니다.
      dispatch(loginSuccess(res.data)); 

      // console.log("🔥 전장 복귀 성공:", res.data.user.nickname);
      // alert(`${res.data.user.nickname} 논객님, 전장에 재입장하셨습니다.`);
      navigate('/topics');

      // 2. ID 존재 여부 확인 (MongoDB의 _id 대응)
      {/*if (userData && (userData._id || userData.id)) {
      
        // 3. 리덕스 상태 업데이트
        dispatch(loginSuccess({ user: userData }));

        // 4. 로컬스토리지 저장 (영속성 유지)
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('user', JSON.stringify(userData));
        if (res.data.token) localStorage.setItem('token', res.data.token);

        // 5. 페이지 이동 (SPA 방식인 navigate 권장)
        alert(`${userData.nickname} 논객님, 전장에 재입장하셨습니다.`);
        navigate('/topics'); 
      
      } else {
        alert('로그인 실패: 서버에서 사용자 식별값을 받지 못했습니다.');
      } */}

    } catch (err) {
      console.error("로그인 에러:", err.response?.data || err.message);
      alert(err.response?.data?.message || '로그인 실패: 닉네임 또는 비밀번호를 확인하십시오.');
    }
  };

  const handleGuestEntry = () => {
    dispatch(setGuestMode());
    navigate('/topics'); // 바로 전장 목록으로 이동
  };

  return (
    <div style={styles.container}>
      <div style={styles.headerSection}>
        <h1 className="responsive-slogan" style={styles.mainSlogan}>유튜브 댓글창을 벗어나,<br /> 진정한 '지성들의 전장'으로.</h1>
        <p className="responsive-sub-slogan" style={styles.subSlogan}>목소리 큰 사람이 아닌,<br /> 가장 정교한 논리를 가진 사람이 승리합니다.</p>
      </div>

      <div style={styles.loginBox}>
        <h2 style={styles.logoText}>THE PIVOT</h2>
        <p style={styles.loginGuide}>지성들의 전장에 입장하십시오.</p>

        {/* 🚩 둘러보기 버튼 추가 */}
        <button 
          type="button" 
          onClick={handleGuestEntry} 
          style={{...styles.submitBtn, marginTop: '0', marginBottom: '15px'}}
        >
          로그인 없이 둘러보기
        </button>
        
        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.inputGroup}>
            <input 
              placeholder="IDENTITY (Nickname)" 
              value={nickname}
              onChange={e => setNickname(e.target.value)}
              autoComplete="username" 
              style={styles.input}
              required
            />
          </div>
          <div style={styles.inputGroup}>
            <input 
              type="password" 
              placeholder="CODE (Password)" 
              value={password}
              onChange={e => setPassword(e.target.value)} 
              autoComplete="current-password"
              style={styles.input}
              required
            />
          </div>
          <button type="submit" style={styles.submitBtn}>
            전장 입성
          </button>
        </form>

        <div style={styles.footer}>
          <span>아직 자격을 갖추지 못하셨습니까?</span>
          <Link to="/register" style={styles.registerLink}>회원가입</Link>
        </div>
      </div>

      <div style={styles.bgDecorationLeft}></div>
      <div style={styles.bgDecorationRight}></div>
    </div>
  );
};

// 스타일 가이드 (기존 스타일 유지)
const styles = {
  container: {
    height: '100vh', background: '#0a0a0a', color: '#ffffff', display: 'flex',
    flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
    fontFamily: "'Noto Sans KR', sans-serif", overflow: 'hidden', position: 'relative'
  },
  headerSection: { textAlign: 'center', marginBottom: '40px', zIndex: 2 },
  mainSlogan: {
    fontSize: '2.5rem', fontWeight: '900', color: '#00d4ff',
    textShadow: '0 0 15px rgba(0, 212, 255, 0.5)', marginBottom: '10px', letterSpacing: '-1px'
  },
  subSlogan: { fontSize: '1.1rem', color: '#888', letterSpacing: '2px' },
  loginBox: {
    background: 'rgba(30, 30, 30, 0.8)', padding: '40px 50px', borderRadius: '2px',
    border: '1px solid #333', boxShadow: '0 20px 50px rgba(0,0,0,0.8)',
    width: '100%', maxWidth: '400px', zIndex: 2, textAlign: 'center'
  },
  logoText: { fontSize: '1.8rem', fontWeight: 'bold', margin: '0 0 5px 0', color: '#fff' },
  loginGuide: { color: '#555', fontSize: '0.9rem', marginBottom: '15px' },
  form: { display: 'flex', flexDirection: 'column', gap: '15px' },
  input: {
    width: '100%', padding: '14px', background: '#121212', border: '1px solid #444',
    color: '#fff', fontSize: '1rem', outline: 'none', boxSizing: 'border-box'
  },
  submitBtn: {
    padding: '15px', background: 'transparent', border: '2px solid #00d4ff',
    color: '#00d4ff', fontSize: '1.1rem', fontWeight: 'bold', cursor: 'pointer',
    marginTop: '10px', transition: 'all 0.3s', textTransform: 'uppercase'
  },
  footer: { marginTop: '25px', fontSize: '0.85rem', color: '#666', display: 'flex', justifyContent: 'center', gap: '10px' },
  registerLink: { color: '#00d4ff', textDecoration: 'none', fontWeight: 'bold' },
  bgDecorationLeft: {
    position: 'absolute', width: '2px', height: '150%', left: '15%', transform: 'rotate(25deg)', opacity: 0.1,
    background: 'linear-gradient(to bottom, transparent, #00d4ff, transparent)'
  },
  bgDecorationRight: {
    position: 'absolute', width: '2px', height: '150%', right: '15%', transform: 'rotate(25deg)', opacity: 0.1,
    background: 'linear-gradient(to bottom, transparent, #ff4e50, transparent)'
  }
};

export default Login;
